module.exports = __webpack_public_path__ + "img/non08.9aa0bf71.png";